import { format } from "date-fns";

// 消費税率
export const CONSUMPTION_TAX_RATE = 10;

// item level
export const ESTIMATE_ITEM_LEVEL = {
  PARENT: 1, // 大項目
  CHILD: 2, // 中項目
  GRAND_CHILD: 3 // 小項目
};

// 端数
export const NUMBER_ROUND = [0, 1, 2, 3, 4];

// 端数処理
export const TYPE_ROUND = ["切り上げ", "切り捨て", "四捨五入"];

// 経費カテゴリ readonly
export const EXPENSE_CATEGORIES_READONLY = ["値引き"];

// RELEASE_DATE
const RELEASE_DATE = new Date("2024-11-30");

export function isNewProject(created: string | Date): boolean {
  if (!created) return false;
  const date = format(new Date(created), "yyyy-MM-dd");

  return new Date(date).getTime() >= RELEASE_DATE.getTime();
}
